export const MODULE_NAME = 'ui.bootstrap.module.tooltip';
import TooltipMod from './tooltip.js';
let compMod = angular.module(MODULE_NAME, [TooltipMod]);
export default compMod = compMod.name;
